import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

function Announcement(props) {
  const content = props.announcement_messages.content;
  return (
    <div className={`${props.show ? "spinner_container" : ""}`}>
      <div className={`announcement_container ${props.show ? "" : "ishidden"}`}>
        <div className="announcement_top">
          <div className="announcement_title">
            <FontAwesomeIcon
              icon={["fas", "exclamation-circle"]}
              style={{ marginRight: "10px" }}
            />
            <FormattedMessage id="special.announcement.title" />
          </div>
          {props.show ? (
            <FontAwesomeIcon
              icon={["fas", "times"]}
              onClick={() => props.setShow(!props.show)}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "exclamation-circle"]}
              onClick={() => props.setShow(!props.show)}
            />
          )}
        </div>
        <div className="announcement_bottom">
          <ul>
            {Object.keys(content).map((item, i) => {
              return (
                <li
                  key={i}
                  dangerouslySetInnerHTML={{ __html: content[item] }}
                ></li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Announcement;
